import { getRentalProductName } from 'containers/Shop/popups/RentalProductPopup'
import { LOCATION_STATES } from 'utils/constants'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { durationLabel } from 'utils/shortTerm'
import { VanUpsellData } from './useVanUpsell'
import { useHistory } from 'react-router-dom'
import { displayPrice } from 'utils/string'
import Popup from 'components/popups/Popup'
import React from 'react'
import './style.scss'

interface VanUpsellPopupProps {
  cartId: string
  data: VanUpsellData
}

/** ldz01: „Hej, a może bus do tego?” — modal między szczegółami zamówienia a koszykiem */
const VanUpsellPopup: React.FC<VanUpsellPopupProps> = ({ cartId, data }) => {
  const { replace } = useHistory()
  const { t, lang } = useTranslation('basket')
  const { t: tRental } = useTranslation('shop.rental')

  const { featured, photo, priceFrom, products, categoryId } = data
  const name = getRentalProductName(featured)

  const goToBasket = () => {
    replace(window.location.pathname, LOCATION_STATES.popup({ type: 'basket' }))
  }

  return (
    <Popup darkBg centered close={goToBasket}>
      <div className='vanUpsell'>
        <div className='vanUpsell__photo'>
          {photo
            ? <img src={photo} alt={name} />
            : <VanIllustration />}
          {priceFrom && <div className='vanUpsell__price --secFont'>
            {tRental('priceFrom')
              .replace('{price}', displayPrice(priceFrom.gross))
              .replace('{duration}', durationLabel(priceFrom.minutes, lang))}
          </div>}
        </div>

        <h3 className='vanUpsell__title --secFont'>{t('vanUpsellModalTitle')}</h3>
        <p className='vanUpsell__desc'>{t('vanUpsellModalDesc')}</p>
        {products.length === 1 && <p className='vanUpsell__car'>
          {name}
        </p>}

        <div className='vanUpsell__buttons'>
          <ArrowBtn
            enlarged
            text={t(products.length === 1 ? 'vanUpsellModalYesOne' : 'vanUpsellModalYes')}
            action={() => {
              // jedno auto: modal z wyborem terminu od razu tutaj, bez przechodzenia do sklepiku;
              // replace zdejmuje wpis z upsellem, więc zamknięcie modala wraca do szczegółów zamówienia
              if (products.length === 1) {
                replace(window.location.pathname, LOCATION_STATES.popup({ type: 'rental', data: featured }))
                return
              }
              replace(`/order/${cartId}/shop/${categoryId}`)
            }}
          />
          <button
            type='button'
            className='vanUpsell__no'
            onClick={goToBasket}>
            {t('vanUpsellModalNo')}
          </button>
        </div>
      </div>
    </Popup>
  )
}

/** uniwersalny obrazek, gdy auto nie ma zdjęcia */
const VanIllustration: React.FC = () => (
  <svg className='vanUpsell__illustration' viewBox='0 0 120 72' aria-hidden='true'>
    <path d='M8 18a6 6 0 0 1 6-6h58a6 6 0 0 1 6 6v8h14.5a6 6 0 0 1 4.9 2.6l11.5 16.6a6 6 0 0 1 1.1 3.4V54a4 4 0 0 1-4 4H8z' fill='currentColor' opacity='0.18' />
    <path d='M80 30h12.2l9.8 14H80z' fill='currentColor' opacity='0.35' />
    <circle cx='30' cy='58' r='9' fill='currentColor' />
    <circle cx='30' cy='58' r='3.5' fill='var(--black, #000)' />
    <circle cx='90' cy='58' r='9' fill='currentColor' />
    <circle cx='90' cy='58' r='3.5' fill='var(--black, #000)' />
  </svg>
)

export default VanUpsellPopup
